import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { ConfigurationProtocolResponse } from '@/modules/configurationModule/detail/local-assays/protocols/services/configuration-protocol/configuration-protocol.dto'
import { CommonPortionTypeResponse } from '@/api/services/common/portion-type/common-portion-type.dto'
import { commonPortionTypeService } from '@/api/services/common/portion-type/common-portion-type.service'

@Component
export default class ConfigurationLocalAssaysProtocolsModalBasicForm extends Vue {
    @Prop(String) readonly actionTitle!: string
    @Prop() readonly protocol!: Partial<ConfigurationProtocolResponse>

    @Emit()
    create(): void {}

    @Emit()
    update(): void {}

    get updateMode(): boolean {
        return !!this.protocol?.id
    }

    get modelValidated(): boolean {
        const hasErrors: boolean = this.$validator.errors.any()
        const isDirty: boolean = this.$_someFieldIsDirty(this.fields)
        return !hasErrors && isDirty
    }

    async getPortionTypes(): Promise<CommonPortionTypeResponse[]> {
        return commonPortionTypeService.getPortionTypes()
    }

    async doAction(): Promise<void> {
        const valid = await this.$validator.validateAll()
        if (valid) {
            if (this.updateMode) {
                this.update() // emits an event
            } else {
                this.create() // emits an event
            }
        }
    }
}
